import { ICreateFeatureRoleRequest } from '../../../../types/administration/features/IFeature';
import { Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { SideSheet } from '../../../../ui-toolkit';
import { SideSheetFormFooter } from '../../../shared/SideSheetFormFooter';
import { FeatureRoleFormFields } from './FeatureRoleFormFields';
import { useCreateFeatureRoleMutation } from '../../../../API/administration/FeaturesAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';

interface IAddFeatureRoleFormProps {
  onCancel: () => void;
}

const initialValues = { name: '', roleId: '', isOn: false };

export const CreateFeatureRoleForm: React.FC<IAddFeatureRoleFormProps> = ({ onCancel }) => {
  const [createFeatureRole] = useCreateFeatureRoleMutation();
  const onSubmit = useCallback(
    async (featureRequest: ICreateFeatureRoleRequest) => {
      const response = await createFeatureRole(featureRequest);
      if (checkForMutationSuccess(response, 'FeatureRole Creation')) {
        onCancel();
      }
    },
    [createFeatureRole, onCancel]
  );
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      <Form>
        <SideSheet
          title={'New Feature Role'}
          onClose={onCancel}
          footer={<SideSheetFormFooter saveButtonText={'Save and Add'} onCancel={onCancel} />}
        >
          <FeatureRoleFormFields />
        </SideSheet>
      </Form>
    </Formik>
  );
};
